var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.portfolioPageEnabled)?_c('LazyTemplatesTemplateLanding'):_c('LazyTemplatesTemplateProject')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }